import React, { useState } from "react";
import jsPDF from "jspdf";
import "./App.css";

const generateQuotationNo = () => {
  const now = new Date();

  const dd = String(now.getDate()).padStart(2, "0");
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const yyyy = now.getFullYear();

  const hh = String(now.getHours()).padStart(2, "0");
  const min = String(now.getMinutes()).padStart(2, "0");

  return `TCW-${dd}${mm}${yyyy}-${hh}${min}`;
};

const defaultItems = [
  {
    name: "Empty Notebook Labels with School Name",
    qty: "",
    rate: ""
  },
  {
    name: "Personalized Notebook Labels with Student Photo",
    qty: "",
    rate: ""
  },
  {
    name: "Student ID Cards",
    qty: "",
    rate: ""
  },
  {
    name: "Book Cover Rolls",
    qty: "",
    rate: ""
  }
];

const QuotationGenerator = () => {

  /* =========================
     STATES
  ========================= */

  const [documentType, setDocumentType] =
    useState("quotation");

  const [gstEnabled, setGstEnabled] =
    useState("no");

  const [form, setForm] = useState({
    quotationNo: generateQuotationNo(),
    date: new Date().toLocaleDateString("en-GB"),
    customerName: "",
    address: "",
    subject: "",
    items: defaultItems
  });

  /* =========================
     HANDLE ITEM CHANGES
  ========================= */

  const handleChange = (
    index,
    field,
    value
  ) => {

    const updated = [...form.items];

    updated[index][field] = value;

    setForm({
      ...form,
      items: updated
    });
  };

  /* =========================
     ADD ITEM
  ========================= */

  const addItem = () => {

    setForm({
      ...form,
      items: [
        ...form.items,
        {
          name: "",
          qty: "",
          rate: ""
        }
      ]
    });
  };

  /* =========================
     DELETE ITEM
  ========================= */

  const deleteItem = (index) => {

    const updated =
      form.items.filter(
        (_, i) => i !== index
      );

    setForm({
      ...form,
      items: updated
    });
  };

  /* =========================
     GENERATE PDF
  ========================= */

  const generatePDF = () => {

    const doc = new jsPDF();

    const box = (
      x,
      y,
      w,
      h
    ) => doc.rect(x, y, w, h);

    const img = new Image();

    img.src = "/tcw.png";

    img.onload = () => {

      /* HEADER */

      box(10, 10, 190, 40);

      doc.addImage(
        img,
        "PNG",
        12,
        17,
        25,
        25
      );

      doc.setFontSize(16);

      doc.setTextColor(
        200,
        0,
        0
      );

      doc.text(
        "TRINGE CREATIVE WORKS",
        40,
        20
      );

      doc.setFontSize(10);

      doc.setTextColor(
        0,
        0,
        0
      );

      let y = 28;

      const gap = 5;

      const line = (text) => {

        doc.text(
          text,
          40,
          y
        );

        y += gap;
      };

      line(
        "1-173/80, Near Sri Chaitanya School,"
      );

      line(
        "Sitafalmandi, Secunderabad,"
      );

      line(
        "Telangana 500061"
      );

      line(
        "Phone: 8978200122"
      );

      line(
        "Email: tringe.in"
      );

      /* RIGHT BOX */

      box(120, 10, 80, 40);

      doc.setFontSize(14);

      doc.text(
        documentType ===
          "quotation"
          ? "QUOTATION"
          : "INVOICE",
        138,
        18
      );

      doc.setFontSize(9);

      doc.text(
        `${
          documentType ===
          "quotation"
            ? "Quotation"
            : "Invoice"
        } No: ${form.quotationNo}`,
        122,
        28
      );

      doc.text(
        `Date: ${form.date}`,
        122,
        34
      );

      /* CUSTOMER */

      box(10, 50, 190, 30);

      doc.text(
        "To:",
        12,
        56
      );

      doc.text(
        form.customerName || "-",
        12,
        62
      );

      doc.text(
        form.address || "-",
        12,
        68
      );

      doc.text(
        `Subject: ${
          form.subject || "-"
        }`,
        12,
        74
      );

      /* TABLE */

      box(10, 80, 190, 70);

      doc.line(
        10,
        90,
        200,
        90
      );

      doc.text(
        "SN",
        12,
        88
      );

      doc.text(
        "Description",
        25,
        88
      );

      doc.text(
        "Qty",
        140,
        88
      );

      doc.text(
        "Rate",
        155,
        88
      );

      doc.text(
        "Amount",
        175,
        88
      );

      let rowY = 100;

      let subtotal = 0;

      form.items.forEach(
        (item, i) => {

          const qty = Number(
            item.qty || 0
          );

          const rate = Number(
            item.rate || 0
          );

          const amount =
            qty * rate;

          subtotal += amount;

          doc.text(
            String(i + 1),
            12,
            rowY
          );

          doc.text(
            item.name || "-",
            25,
            rowY,
            {
              maxWidth: 100
            }
          );

          doc.text(
            String(qty),
            140,
            rowY
          );

          doc.text(
            String(rate),
            155,
            rowY
          );

          doc.text(
            String(amount),
            175,
            rowY
          );

          rowY += 8;
        }
      );

      /* TOTAL */

      box(10, 150, 190, 40);

      if (documentType === "quotation") {

  doc.text(
    "Note: Quote valid for 10 days",
    12,
    158
  );

}

      if (
        gstEnabled === "yes"
      ) {

        const sgst =
          subtotal * 0.09;

        const cgst =
          subtotal * 0.09;

        const total =
          subtotal +
          sgst +
          cgst;

        doc.text(
          `Sub Total: ${subtotal}`,
          130,
          158
        );

        doc.text(
          `SGST (9%): ${sgst}`,
          130,
          164
        );

        doc.text(
          `CGST (9%): ${cgst}`,
          130,
          170
        );

        doc.text(
          `Grand Total: ${total}`,
          130,
          176
        );

      } else {

        doc.text(
          `Total: ${subtotal}`,
          130,
          164
        );
      }

      /* TERMS */

      box(10, 190, 190, 40);

      doc.text(
        "Terms & Conditions:",
        12,
        198
      );

      doc.text(
        "1. Delivery within 5 days",
        12,
        204
      );

      doc.text(
        "2. Advance: 10%",
        12,
        210
      );

      doc.text(
        "For Tringe Creative Works",
        130,
        210
      );

      doc.text(
        "Authorized Signature",
        130,
        225
      );

      doc.text(
        "This is a Software Generated Document.",
        45,
        235
      );

      doc.save(
        documentType ===
          "quotation"
          ? "quotation.pdf"
          : "invoice.pdf"
      );

      /* RESET NUMBER */

      setForm({
        ...form,
        quotationNo:
          generateQuotationNo()
      });
    };
  };

  return (
    <div className="container">

      <h2 className="title">
        Quotation / Invoice Generator
      </h2>

      <div className="card">

       {/* TOP OPTIONS */}

<div className="topOptions">

  {/* DOCUMENT TYPE BOX */}

  <div className="optionBox">

    <label className="sectionTitle">
      Document Type
    </label>

    <div className="radioGroup">

      <label className="radioLabel">

        <input
          type="radio"
          name="documentType"
          value="quotation"
          checked={
            documentType === "quotation"
          }
          onChange={(e) =>
            setDocumentType(
              e.target.value
            )
          }
        />

        <span>Quotation</span>

      </label>

      <label className="radioLabel">

        <input
          type="radio"
          name="documentType"
          value="invoice"
          checked={
            documentType === "invoice"
          }
          onChange={(e) =>
            setDocumentType(
              e.target.value
            )
          }
        />

        <span>Invoice</span>

      </label>

    </div>

  </div>

  {/* GST BOX */}

  <div className="optionBox">

    <label className="sectionTitle">
      GST
    </label>

    <div className="radioGroup">

      <label className="radioLabel">

        <input
          type="radio"
          name="gstType"
          value="no"
          checked={
            gstEnabled === "no"
          }
          onChange={(e) =>
            setGstEnabled(
              e.target.value
            )
          }
        />

        <span>No</span>

      </label>

      <label className="radioLabel">

        <input
          type="radio"
          name="gstType"
          value="yes"
          checked={
            gstEnabled === "yes"
          }
          onChange={(e) =>
            setGstEnabled(
              e.target.value
            )
          }
        />

        <span>Yes</span>

      </label>

    </div>

  </div>

</div>
        {/* CUSTOMER */}

        <input
          className="input"
          placeholder="Customer Name"
          value={form.customerName}
          onChange={(e) =>
            setForm({
              ...form,
              customerName:
                e.target.value
            })
          }
        />

        <input
          className="input"
          placeholder="Address"
          value={form.address}
          onChange={(e) =>
            setForm({
              ...form,
              address:
                e.target.value
            })
          }
        />

        <input
          className="input"
          placeholder="Subject"
          value={form.subject}
          onChange={(e) =>
            setForm({
              ...form,
              subject:
                e.target.value
            })
          }
        />

        <h4>Items</h4>

        {form.items.map(
          (item, index) => (

            <div
              key={index}
              style={{
                display: "flex",
                gap: 8,
                marginBottom: 10,
                flexWrap: "wrap"
              }}
            >

              <input
                className="input"
                style={{ flex: 3 }}
                placeholder="Item Description"
                value={item.name}
                onChange={(e) =>
                  handleChange(
                    index,
                    "name",
                    e.target.value
                  )
                }
              />

              <input
                className="input"
                style={{ width: 80 }}
                type="number"
                placeholder="Qty"
                value={item.qty}
                onChange={(e) =>
                  handleChange(
                    index,
                    "qty",
                    e.target.value
                  )
                }
              />

              <input
                className="input"
                style={{ width: 90 }}
                type="number"
                placeholder="Rate"
                value={item.rate}
                onChange={(e) =>
                  handleChange(
                    index,
                    "rate",
                    e.target.value
                  )
                }
              />

              <button
                className="btn"
                style={{
                  width: 50,
                  marginTop: 0
                }}
                onClick={() =>
                  deleteItem(index)
                }
              >
                X
              </button>

            </div>
          )
        )}

        <button
          className="btn"
          onClick={addItem}
        >
          + Add Item
        </button>

        <button
          className="btn"
          style={{ marginTop: 20 }}
          onClick={generatePDF}
        >
          Download PDF
        </button>

      </div>
    </div>
  );
};
export default QuotationGenerator;